module.exports = __webpack_public_path__ + "img/page50.dfb56fc1.gif";